import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import ConfirmDialog from "../../shared/ui/ConfirmDialog";
import { formatDateTimeBR } from "../../shared/ui/format";
import { reactivateCompany } from "../../services/admin/companies";
import { getApiErrorCode, getApiErrorMessage } from "../../utils/apiError";
import { AdminCompany } from "./types";

export type ReactivateCompanyDialogProps = {
  company: AdminCompany | null;
  onClose: () => void;
  onDone: (message: string) => void;
};

// deactivatedAt é um timestamp: a data sai no fuso local (dd/MM/yyyy da data/hora local).
const localDate = (value?: string | null) => formatDateTimeBR(value || null).slice(0, 10);

export default function ReactivateCompanyDialog({ company, onClose, onDone }: ReactivateCompanyDialogProps) {
  const confirm = async () => {
    if (!company) return;
    try {
      await reactivateCompany(company.id);
      onDone(`Empresa “${company.name}” reativada.`);
    } catch (e) {
      // Outra pessoa reativou antes: conta como feito.
      if (getApiErrorCode(e) === "COMPANY_ALREADY_ACTIVE") {
        onDone(`A empresa “${company.name}” já estava ativa. A lista foi atualizada.`);
        return;
      }
      throw e;
    }
  };
  const who = company?.deactivatedBy?.name;
  const when = localDate(company?.deactivatedAt);
  const why = company?.deactivationReason;
  return (
    <ConfirmDialog
      open={Boolean(company)}
      onClose={onClose}
      title="Reativar empresa"
      context={company ? `${company.name} · #${company.id} · CNPJ ${company.cnpj}` : undefined}
      message={
        <Stack spacing={1.5}>
          <Alert severity="info">
            A empresa volta às listas e filtros, e os médicos voltam a poder pedir antecipação por ela.
          </Alert>
          {when && (
            <Typography sx={{ fontSize: 13, color: "text.secondary" }}>
              {`Desativada em ${when}${who ? ` por ${who}` : ""}${why ? ` — “${why}”` : ""}.`}
            </Typography>
          )}
        </Stack>
      }
      confirmLabel="Reativar empresa"
      cancelLabel="Cancelar"
      onConfirm={confirm}
      errorMessage={(e) => getApiErrorMessage(e, "Não foi possível reativar a empresa.")}
    />
  );
}
